import { memo, useCallback } from 'react';
import { useMenuContext } from "../../mega-menu-provider";
import MobileMenuTrigger from "../mobile-menu-trigger/mobile-menu-trigger";
import { TopMenuList } from "./top-menu.styles";
import TopMenuItem from "./top-menu-item";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TopMenu = function TopMenu(_ref) {
  var menuItems = _ref.menuItems,
    mobileMenuTriggerOpenLabel = _ref.mobileMenuTriggerOpenLabel,
    mobileMenuTriggerCloseLabel = _ref.mobileMenuTriggerCloseLabel;
  var _useMenuContext = useMenuContext(),
    palette = _useMenuContext.palette,
    isMobileMenuOpen = _useMenuContext.isMobileMenuOpen,
    isUserDropdownVisible = _useMenuContext.isUserDropdownVisible,
    cookieBannerHeight = _useMenuContext.cookieBannerHeight,
    activeSubMenuItem = _useMenuContext.activeSubMenuItem,
    setIsMobileMenuOpen = _useMenuContext.setIsMobileMenuOpen,
    setActiveSubMenuItem = _useMenuContext.setActiveSubMenuItem,
    onSubMenuItemClick = _useMenuContext.onSubMenuItemClick,
    subMenuElementsRef = _useMenuContext.subMenuElementsRef;
  var handleMobileMenuOpen = useCallback(function () {
    setIsMobileMenuOpen(true);
  }, [setIsMobileMenuOpen]);
  var handleMobileMenuClose = useCallback(function () {
    setActiveSubMenuItem(null);
    setIsMobileMenuOpen(false);
  }, [setIsMobileMenuOpen, setActiveSubMenuItem]);
  var handleSubMenuOpen = useCallback(function (_ref2) {
    var item = _ref2.item;
    setActiveSubMenuItem(item);
  }, [setActiveSubMenuItem]);
  var handleSubMenuClose = useCallback(function () {
    setActiveSubMenuItem(null);
  }, [setActiveSubMenuItem]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MobileMenuTrigger, {
      openLabel: mobileMenuTriggerOpenLabel,
      closeLabel: mobileMenuTriggerCloseLabel,
      isMobileMenuOpen: isMobileMenuOpen,
      onClick: isMobileMenuOpen ? handleMobileMenuClose : handleMobileMenuOpen
    }), /*#__PURE__*/_jsx(TopMenuList, {
      isMobileMenuOpen: isMobileMenuOpen,
      isUserDropdownVisible: isUserDropdownVisible,
      cookieBannerHeight: cookieBannerHeight,
      children: menuItems.map(function (menuItem) {
        return /*#__PURE__*/_jsx(TopMenuItem, {
          palette: palette,
          subMenuElementRef: function subMenuElementRef(element) {
            if (!menuItem.id || !(subMenuElementsRef !== null && subMenuElementsRef !== void 0 && subMenuElementsRef.current)) {
              return;
            }
            subMenuElementsRef.current[menuItem.id] = element;
          },
          onMenuOpen: handleSubMenuOpen,
          onMenuClose: handleSubMenuClose,
          onSubMenuItemClick: onSubMenuItemClick,
          isActive: (activeSubMenuItem === null || activeSubMenuItem === void 0 ? void 0 : activeSubMenuItem.id) === menuItem.id,
          item: menuItem
        }, menuItem.id);
      })
    })]
  });
};
export default /*#__PURE__*/memo(TopMenu);